module.exports = __webpack_public_path__ + "static/media/dead.b2fc5672.svg";